import React, { useState, useEffect } from 'react';
import DashboardTable from '../Dashboards/DashboardTable';


const ConflictingScheduleTable = (props) => {
     const rowData = [
        {
          id: 'a',
          conflict: 'Schedule Name 1',
          priority: 'P1'
        },
        {
          id: 'b',
          conflict: 'Schedule Name 2',
          priority: 'P4'
        },
        {
          id: 'c',
          conflict: 'Schedule Name 3',
          priority: 'P1'
        },
        {
          id: 'd',
          conflict: 'Schedule Name 4',
          priority: 'P3'
        },
        {
          id: 'e',
          conflict: 'Schedule Name 5',
          priority: 'P2'
        },
        {
            id: 'f',
            conflict: 'Schedule Name 6',
            priority: 'P2'
        },
        {
            id: 'g',
            conflict: 'Schedule Name 7',
            priority: 'P2'
        },
      ];
      
       const headerData = [
        {
          key: 'conflict',
          header: 'Conflicting Schedule',
        },
        {
          key: 'priority',
          header: 'Priority',
        }
      ];

      
    const [conflictingSchedules, setConflictingSchedules] = useState(rowData);
    const [conflictingSchedulesLoading, setconflictingSchedulesLoading] = useState(false);
    // const [conflictingPriority, setconflictingPriority] = useState(["P1", "P2", "P3"]);

    useEffect(() => {

    }, []);
  
    return (
        <section className="conflicts-priority">
            <div className="conflicts-table">
                <DashboardTable size="tall" loading={conflictingSchedulesLoading} rows={conflictingSchedules} headers={headerData}
                    showPagination={true} />
            </div>
        </section>
    );
}

export default ConflictingScheduleTable
